export const RESOURCEAPIMESSAGE = {
  RESOURCEAPIMESSAGE_SET_SELECTED: "RESOURCEAPIMESSAGE_SET_SELECTED",
  RESOURCEAPIMESSAGE_CLEAR_SELECTED: "RESOURCEAPIMESSAGE_CLEAR_SELECTED",
};
